<template>
  <div>
    <span v-if="hotelData.adult > 0 || hotelData.children > 0">
      {{ hotelData.adult }}成人{{hotelData.children}}儿童
      <span>/</span>
    </span>
    <span v-if="hotelData.star != ''">{{hotelData.star}}/</span>
    <span v-if="hotelData.location != ''">{{hotelData.location}}/</span>
    <span v-if="hotelData.breakfast != ''">{{hotelData.breakfast }}</span>
    <p v-for="(room, index) in hotelData.hotelRoomList" :key="index" style="margin-top:0.05rem">
      <span v-if="room.roomNumber > 0 && room.roomNumber != ''">{{ room.roomNumber }}间</span>
      <span v-if="room.hotelRoomName != ''">
        {{ room.hotelRoomName }}
      </span>
      <span v-if="room.roomBudget > 0 && room.roomBudget != ''"><span>锁死预算:</span>{{ room.roomBudget }}{{room.currency}}/间</span>
    </p>
    <p class="span1" style="margin-top:0.05rem">{{ hotelData.remarks }} </p>
  </div>
</template>

<script>
export default {
  props:{
    hotelData:{
      type:Object,
      default:()=>{return {}}
    }
  }
}
</script>

<style>

</style>